import React, { useState } from "react";
import qrImage from "../../assets/images/Google_Link.png";

const Feedback = () => {

  const reviewLink = "https://g.page/r/CbI31gOBn4tcEBM/review";

  const [showModal, setShowModal] = useState(false);
  const [rating, setRating] = useState(0);

  const [form, setForm] = useState({
    name: "",
    mobile: "",
    message: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = { ...form, rating };
    console.log("Feedback:", data);

    alert("Thank you for your feedback!");

    // Redirect if good rating
    if (rating >= 4) {
      window.open(reviewLink, "_blank");
    }

    setForm({ name: "", mobile: "", message: "" });
    setRating(0);
    setShowModal(false);
  };

  return (
    <div className="container py-5 text-center">

      <h2 className="mb-4 text-primary">Share Your Experience</h2>

      {/* Buttons */}
      <div className="d-flex justify-content-center gap-3 flex-wrap mb-4">

        <a
          href={reviewLink}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-warning btn-lg fw-bold"
        >
          ⭐ Give Review on Google
        </a>

        <button
          className="btn btn-outline-primary btn-lg"
          onClick={() => setShowModal(true)}
        >
          📝 Submit Feedback
        </button>

      </div>

      {/* ✅ Google Review + QR Section (OUTSIDE buttons div) */}
      <section className="py-4 text-center bg-white">
        <h4 className="mb-3">Scan & Review</h4>

        <div style={{
          display: "inline-block",
          padding: "20px",
          border: "2px solid #e0e0e0",
          borderRadius: "20px",
          backgroundColor: "#fafafa"
        }}>
          <img
            src={qrImage}
            alt="Scan to review"
            style={{ maxWidth: "200px" }}
          />
          <p className="mt-2">Scan QR to give feedback</p>
        </div>
      </section>

      {/* Modal */}
      {showModal && (
        <>
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog">
              <div className="modal-content">

                <div className="modal-header">
                  <h5 className="modal-title">Patient Feedback</h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>

                <div className="modal-body">

                  <form onSubmit={handleSubmit}>

                    <div className="mb-3">
                      <label className="form-label">Full Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Mobile Number</label>
                      <input
                        type="tel"
                        className="form-control"
                        name="mobile"
                        value={form.mobile}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="mb-3 text-center">
                      <label className="form-label d-block">Rating</label>
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span
                          key={star}
                          style={{
                            fontSize: "28px",
                            cursor: "pointer",
                            color: star <= rating ? "#ffc107" : "#ccc"
                          }}
                          onClick={() => setRating(star)}
                        >
                          ★
                        </span>
                      ))}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Your Feedback</label>
                      <textarea
                        className="form-control"
                        rows="3"
                        name="message"
                        value={form.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>

                    <button className="btn btn-primary w-100">
                      Submit Feedback
                    </button>

                  </form>

                </div>

              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}

    </div>
  );
};

export default Feedback;